import { useEffect } from 'react'
import {
    useGetIdsHealthcareservicesHcsIdPatientsPatientId,
    usePutIdsHealthcareservicesHcsIdPatientsPatientId,
} from '@toktokdoctech/tokapi-client'
import { useParams } from 'react-router-dom'
import { PatientEditionProps } from './_props'
import CommonLoaderBackdrop from '../../Common/CommonLoaderBackdrop'
import PatientForm from './PatientForm'
import { defaultPatientFormContextValues, PatientFormContextProvider } from '../context/PatientFormContext'
import { RouterRouteId } from '../../../routers/_props'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import useCurrentUser from '../../../hooks/useCurrentUser'
import { useAddLogMutation } from '../../../api/mutations/__generated__/addLog.gql'
import useAutomaticIdentityValidation from '../../../hooks/useAutomaticIdentityValidation'
import { transformPatientDetailToFormData } from './services/transformPatientDetailToFormData'
import { useGetInsi } from './services/useGetInsi'
import { PatientErrorDisclaimer } from './PatientErrorDisclaimer'

export const PatientEdition = ({ isExternal }: PatientEditionProps) => {
    const currentHcs = useCurrentHcs()
    const currentUser = useCurrentUser()
    const { id } = useParams<RouterRouteId>()
    const { isAutomaticIdentityValidationDisabled } = useAutomaticIdentityValidation()

    const { data, isFetching, error } = useGetIdsHealthcareservicesHcsIdPatientsPatientId(currentHcs.id, id ?? '', {
        query: {
            enabled: !!id,
            refetchOnWindowFocus: false,
        },
    })

    // const [updatePatient] = useUpdatePatientMutation()
    const { insi, isLoading: isInsiLoading, error: insiError } = useGetInsi(data?.insiStatus?.toUpperCase() ?? null)

    const [sendLog] = useAddLogMutation()
    const updatePatientMutation = usePutIdsHealthcareservicesHcsIdPatientsPatientId()

    const isLoading = isFetching || isInsiLoading
    const hasError = error || insiError

    useEffect(() => {
        if (id) {
            // TODO: disabled cause not working
            // need to be replaced by tokapi endpoint
            // updatePatient({
            //     variables: {
            //         input: {
            //             id,
            //             fields: {
            //                 actionHistory: {
            //                     createAndAdd: [
            //                         createAndAddActionHistory({
            //                             patientId: id,
            //                             user: currentUser,
            //                             mode: historyActionType.ACCESS,
            //                         }),
            //                     ],
            //                 },
            //             },
            //         },
            //     },
            // })
            sendLog({
                variables: {
                    input: {
                        hcsId: currentHcs.id,
                        fromApp: 'IDS',
                        userId: currentUser.id,
                        message: `[Patient] Accès patient ${id}`,
                        logLevel: 'INFO',
                    },
                },
            })
        }
    }, [id])

    if (hasError) return <PatientErrorDisclaimer />

    if (!id || isLoading || !data)
        return <CommonLoaderBackdrop open label="Chargement des informations du patient..." />

    const patientFormData = transformPatientDetailToFormData(data, isAutomaticIdentityValidationDisabled ?? false)

    return (
        <PatientFormContextProvider
            initialValues={{
                isExternal,
                patientId: id,
                mode: 'EDITION',
                ins: {
                    ...defaultPatientFormContextValues.ins,
                    identityStatus: insi,
                },
                originalIdentityStatus: insi,
            }}
        >
            <PatientForm data={patientFormData} />
        </PatientFormContextProvider>
    )
}
